const { UPLOAD_KNOWLEDGECENTER_DOC, UPLOAD_KNOWLEDGECENTER_DOC_SUCCESS, UPLOAD_KNOWLEDGECENTER_DOC_FAIL, GET_KNOWLEDGECENTER_DOC, GET_KNOWLEDGECENTER_DOC_SUCCESS, GET_KNOWLEDGECENTER_DOC_FAIL, RM_KNOWLEDGECENTER_DOC, RM_KNOWLEDGECENTER_DOC_SUCCESS, RM_KNOWLEDGECENTER_DOC_FAIL } = require("./constant");

const initialState = {
    successMsg: "",
    error: "",
    Loading: false,
    uploadedFiles: []
}

const KnowledgeCenterReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPLOAD_KNOWLEDGECENTER_DOC:

            return {
                ...state,
                successMsg: "",
                error: "",
                Loading: true
            }
        case UPLOAD_KNOWLEDGECENTER_DOC_SUCCESS:
            return {
                ...state,
                Loading: false,
                successMsg: action.payload
            }
        case UPLOAD_KNOWLEDGECENTER_DOC_FAIL:
            return {
                ...state,
                Loading: false,
                error: action.payload
            }
        case GET_KNOWLEDGECENTER_DOC:
            return {
                ...state,
                Loading: true,
                error: "",
                successMsg: ""
            }
        case GET_KNOWLEDGECENTER_DOC_SUCCESS:
            return {
                ...state,
                Loading: false,
                uploadedFiles: action.payload,
            }
        case GET_KNOWLEDGECENTER_DOC_FAIL:
            return {
                ...state,
                error: action.payload,
                Loading: false
            }

        case RM_KNOWLEDGECENTER_DOC:
            return {
                ...state,
                error: "",
                Loading: true,
                successMsg: ""
            }

        case RM_KNOWLEDGECENTER_DOC_SUCCESS:
            return {
                ...state,
                Loading: false,
                successMsg: action.payload
            }
        case RM_KNOWLEDGECENTER_DOC_FAIL:
            return {
                ...state,
                Loading: false,
                error: action.payload
            }

        default:
            return state
    }
}

export default KnowledgeCenterReducer;